import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { c as l, f as n } from "../../../create-component-CBAeEoQ6.js";
import { c as m } from "../../../index-CROKJrb5.js";
import { AccordionCaretUpIcon as p } from "../../Icon/icons/AccordionCaretUpIcon/index.js";
import { Typography as f } from "../../Typography/index.js";
const b = m({
  base: "cur-flex cur-flex-col cur-gap-y-4 cur-p-4 cur-border-b-2 cur-border-b-border-disabled cur-text-left cur-cursor-pointer cur-transition-all hover:cur-bg-surface-neutral-hover active:cur-bg-surface-neutral-selected focus-visible:cur-outline"
}), j = l(
  "InteractiveListItem",
  n(
    ({ as: t, children: c, className: s, href: e, title: o, ...a }, u) => {
      const i = t || e ? "a" : "button";
      return /* @__PURE__ */ r.jsxs(
        i,
        {
          ref: u,
          className: b({ className: s }),
          href: e,
          role: "listitem",
          ...a,
          children: [
            /* @__PURE__ */ r.jsxs("span", { className: "cur-flex cur-w-full cur-items-center", children: [
              /* @__PURE__ */ r.jsx(f, { className: "cur-grow", size: "subhead", weight: "bold", children: o }),
              /* @__PURE__ */ r.jsx(p, { className: "cur-grow-0 cur-rotate-90" })
            ] }),
            c
          ]
        }
      );
    }
  )
);
export {
  j as InteractiveListItem
};
//# sourceMappingURL=index.js.map
